import { render } from "./Dashboard.vue?vue&type=template&id=b578dee0&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=b578dee0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b578dee0"

export default script